export default __webpack_public_path__ + "static/media/ARIZONA STATE UNIVERSITY,TEMPE.9529ade0.png";